module.exports = __webpack_public_path__ + "img/enquiries.697ba5b2.svg";